import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  viewBox: "0 0 19 18",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "currentColor",
  d: "M18.542 2.667c-.637.37-1.416.59-2.124.664.779-.516 1.345-1.327 1.628-2.286a8.01 8.01 0 0 1-2.406 1.032C14.931 1.267 14.01.75 12.95.75c-2.053 0-3.752 1.844-3.752 4.204 0 .295 0 .663.07.958-3.114-.147-5.874-1.843-7.715-4.35-.354.59-.495 1.327-.495 2.138 0 1.475.637 2.728 1.628 3.466-.637 0-1.203-.221-1.699-.516v.073c0 1.992 1.274 3.688 2.973 4.13a4.02 4.02 0 0 1-.991.148c-.212 0-.495 0-.708-.074.496 1.696 1.84 2.876 3.469 2.876-1.275 1.106-2.903 1.77-4.601 1.77-.284 0-.567 0-.92-.074 1.627 1.18 3.61 1.918 5.733 1.918 6.866 0 10.618-6.343 10.618-11.873v-.517c.85-.737 1.486-1.475 1.982-2.36Z"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }